<template>
  <div class="diff-container" v-if="dataInfo">
    <div class="verifyStatus">
      <van-icon :name="topPartVerifyInfo.iconName" color="#ffffff" size="60" />
      <div class="rightPart">
        <div class="title" v-text="topPartVerifyInfo.title"></div>
        <div class="tip" v-text="topPartVerifyInfo.tip"></div>
      </div>
    </div>
    <div class="diff_price_top priceInfo">
      <div class="subName">平台价格信息</div>
      <div class="topPartItem" v-if="dataInfo.CouponAmount">
        <div class="subLeftPart">领优惠券</div>
        <div class="subRightPart">
          <div class="coupon">券{{ dataInfo.CouponAmount }}元</div>
        </div>
      </div>
      <div v-if="getTempOrderInfo.FreightType" class="topPartItem">
        <div class="subLeftPart">
          运费（商品不包邮）
        </div>
        <div class="subRightPart">￥{{ getTempOrderInfo.Freight.toFixed(2) }}</div>
      </div>
      <div class="topPartItem">
        <div class="subLeftPart">
          {{ dataInfo.CouponAmount ? '券后付款金额' : '付款金额' }}
        </div>
        <div class="subRightPart">￥{{ dataInfo.ProductPrice.toFixed(2) }}</div>
      </div>
    </div>
    <div class="container-box">
      <div class="diff_price_top">
        <div class="subName">提交差价反馈</div>
        <p>请在{{ PLATFORM_TYPE_DETAIL[platformType].collectively }}APP与平台价格信息进行核对，选择存在差价的原因反馈：</p>
      </div>
      <div class="diff_price_radio b_fff">
        <sh-radio :options="radioOptions" :isCheckStatus="true" :choseRadio="dataInfo.SpreadResonTypeVo + 1" class="sh-radio"> </sh-radio>
        <mt-field
          readonly
          v-show="dataInfo.SpreadResonTypeVo === 3"
          label="描述情况"
          type="textarea"
          :rows="dataInfo.Remark.length > 14 ? '3' : '1'"
          placeholder="请简单描述存在差价的原因"
          :attr="{ maxlength: 50 }"
          v-model="dataInfo.Remark"
        >
        </mt-field>
      </div>
      <div class="order_from" v-if="dataInfo.AuditPicUrl">
        <!-- <div class="b_black err-b fs-26">
          <span>有效的差价截图，可有助于我们尽快核实（选填）</span>
          <span class="iconfont icon-sanjiaoxing"></span>
        </div> -->
        <div class="subTitle">已上传截图</div>
        <!-- upload -->
        <div class="weui-cells sub-upload">
          <div class="weui-cell">
            <div class="weui-uploader">
              <div class="weui-uploader__bd">
                <div class="weui-uploader__files">
                  <div v-if="dataInfo.AuditPicUrl" class="weui-uploader__file" :class="[isUploading || isUploadFail ? 'weui-uploader__file_status' : '']" @click="previewImage">
                    <img class="weui-uploader__img" v-if="dataInfo.AuditPicUrl" :src="dataInfo.AuditPicUrl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 65px"></div>
    <div class="order-btn b_fff flex">
      <div>
        <mt-button type="default" @click="goBack" class="normalBtn shCancelBtn">返回</mt-button>
      </div>
      <div class="btn-margin">
        <mt-button v-if="dataInfo.SpreadAuditStatus === 0" class="normalBtn shPrimaryBtn" type="danger" :disabled="btnLoading" @click="cancelFeebback({ taskID: taskID, goBack: true })"
          >取消反馈
        </mt-button>
        <mt-button v-else class="normalBtn shPrimaryBtn" type="danger" @click="reSubmit()" :disabled="btnLoading">重新提交 </mt-button>
        <!-- <mt-button
          v-else
          class="normalBtn shPrimaryBtn"
          type="danger"
          @click="cancelOrder"
          :disabled="btnLoading"
          >取消订单
        </mt-button> -->
      </div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="previewImgSrc" :class="{ 'mode-type': imgModelType }"> </preview-dialog>
    <!-- 取消订单弹窗 -->
    <cancel-order-popup
      :isShow="isShowCancelOrderPopup"
      :isShowChangeKeyWordBtn="isShowChangeKeyWordBtn"
      :isWaitingSearch="false"
      @changeKeyWord="customChangeKeyWordEvent"
      @confirm="customCancelSaleTaskAccept"
      @close="closeCancelOrderPopup"
    ></cancel-order-popup>
  </div>
</template>

<script>
import axios from 'axios'
import { IMG_BASE_URL } from '@/config'
import { Toast } from 'mint-ui'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import ShRadio from '@/components/puppetComponent/ShRadio'
import { mapGetters } from 'vuex'
import { Icon } from 'vant'
import { GetSpreadFeedbackAuditInfo } from '@/api/my'
import orderHandler from '@/mixins/orderHandler'
import cancelOrder from '@/mixins/cancelOrder'

export default {
  mixins: [orderHandler, cancelOrder],
  data() {
    return {
      dataInfo: null,
      radioCheckValue: '',
      radioOptions: [
        { label: '没有与平台价格一致的商品型号', value: 1 },
        { label: '没有优惠券可以领', value: 2 },
        { label: '商品不包邮', value: 3 },
        { label: '其他', value: 4, hiddenBtn: true }
      ],
      otherDiffReason: '',
      isUploading: false,
      isUploadFail: false,
      uploadingProgress: 0,
      uploadImgSrc: '',
      uploadUserInfo: {},
      taskID: null,
      showRootPath: IMG_BASE_URL,
      previewImgSrc: '',
      previewDialogShow: false,
      imgModelType: '',
      btnLoading: false,
      platformType: 0, // 0: 淘宝, 1: 拼多多
      couponAmount: '',
      productPrice: ''
    }
  },
  computed: {
    ...mapGetters(['getTempOrderInfo']),
    topPartVerifyInfo() {
      let tempObj = {
        iconName: 'clock-o',
        title: '等待审核',
        tip: '以下是你已提交的差价反馈信息，正在等待管理员审核。如发现实际价格无误，可操作取消反馈。'
      }
      switch (this.dataInfo.SpreadAuditStatus) {
        case 0:
          // 待审核
          tempObj = {
            iconName: 'clock-o',
            title: '等待审核',
            tip: '以下是你已提交的差价反馈信息，正在等待管理员审核。如发现实际价格无误，可操作取消反馈。'
          }
          break
        case 1:
          // 审核通过
          tempObj = {
            iconName: 'passed',
            title: '审核通过',
            tip: this.dataInfo.AuditRemark
          }
          break
        case 2:
          // 审核不通过
          tempObj = {
            iconName: 'close',
            title: '审核不通过',
            tip: this.dataInfo.AuditRemark
          }
          break
        default:
          break
      }
      return tempObj
    }
  },
  components: {
    PreviewDialog,
    ShRadio,
    'van-icon': Icon
  },
  created() {
    this.taskID = this.getTempOrderInfo.TaskID
  },
  mounted() {
    if (this.taskID) {
      this.getSpreadFeedbackAuditInfo()
    } else {
      Toast('无任务ID')
      this.$router.go(-1)
    }
  },
  methods: {
    // 图片上传
    selectImgChange(event) {
      let _this = this
      let rootPath = this.showRootPath
      let file = event.target.files[0]
      if (file) {
        let data = new FormData()
        data.append('diffPriceFeedbackUpload', file)
        document.querySelector('.upload-input').value = ''
        axios({
          method: 'post',
          url: this.uploadUserInfo.uploadUrl,
          params: {
            loginName: this.uploadUserInfo.loginName,
            secret: this.uploadUserInfo.password
          },
          data: data,
          timeout: 60000,
          onUploadProgress: function(progressEvent) {
            // 显示相应的上传进度
            let percent = (progressEvent.loaded / progressEvent.total) * 100
            _this.uploadingProgress = parseInt(percent)
            _this.isUploading = true
            _this.isUploadFail = false
          }
        })
          .then((res) => {
            if (res.status === 200 && res.data.StatusCode === 200) {
              // 上传成功，展示图片，隐藏进度条
              this.uploadImgSrc = rootPath + res.data.Message
              this.isUploading = false
              this.isUploadFail = false
            } else {
              Toast(res.Message)
              this.uploadingProgress = 0
              this.uploadImgSrc = ''
              this.isUploading = false
              this.isUploadFail = true
            }
          })
          .catch(() => {
            Toast('上传图片失败！请重新上传')
            this.uploadingProgress = 0
            this.uploadImgSrc = ''
            this.isUploading = false
            this.isUploadFail = true
          })
      }
    },
    previewImage() {
      this.previewImgSrc = this.dataInfo.AuditPicUrl
      this.previewDialogShow = true
    },
    reasonKeyDown() {
      if (this.otherDiffReason) {
        this.otherDiffReason = this.otherDiffReason.replace(/(^[\r\n\s]*)|([\r\n\s]*$)/g, '')
      }
    },
    reasonKeyBlur() {
      this.reasonKeyDown()
      setTimeout(function() {
        window.scrollTo(0, 0)
      }, 100)
    },
    goBack() {
      this.$router.go(-1)
    },
    // 获取差价反馈审核结果接口
    getSpreadFeedbackAuditInfo() {
      GetSpreadFeedbackAuditInfo({ taskID: this.taskID })
        .then((res) => {
          this.dataInfo = res.Data
          if (this.dataInfo.SpreadAuditStatus === 2) {
            this.handelCancelOrder(this.getTempOrderInfo)
          }
          this.platformType = res.Data.PlatformType
        })
        .catch((err) => {
          if (err.ErrMsg) {
            this.$toast(err.ErrMsg)
          }
        })
    },
    // 自定义取消订单按钮成功和失败失败后的操作
    customCancelSaleTaskAccept({ orderCancelReason = '' }) {
      this.cancelSaleTaskAccept({
        orderCancelReason: orderCancelReason,
        success: () => {
          this.$router.replace({
            name: 'order'
          })
        },
        fail: (errMsg) => {
          if (errMsg === '任务已取消') {
            this.$toast('任务已取消，无需重复操作，将自动跳转首页')
            setTimeout(() => {
              this.$router.push({ name: 'souhuo' })
            }, 3000)
          } else {
            this.$toast(errMsg)
          }
        }
      })
    },
    // 重新提交
    reSubmit() {
      const { FeedbackCount } = this.dataInfo
      // 若小于3，则重新进入差价反馈提交页面
      if (FeedbackCount < 3) {
        this.$router.push({
          name: 'diffPeiceFeedback'
        })
      } else {
        // 若大于等于3，则给出异常提示：您已多次提交差价反馈，无法再次提交；若商品仍存在差价，请联系人工客服处理
        this.$dialog
          .alert({
            title: '提示',
            message: '您已多次提交差价反馈，无法再次提交；若商品仍存在差价，请联系人工客服处理'
          })
          .then(() => {
            // on close
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './css/index.scss';
.subTitle {
  margin-top: 3%;
  background-color: #fff;
  padding: 10px 20px 0;
  font-size: 15px;
  font-weight: 700;
}
.sub-upload .weui-cell {
  padding: 10px 20px 15px;
}
</style>
